var React = require('react');

function PlusIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M13.3,22c0.8,0,1.4-0.7,1.4-1.5V3.4C14.6,2.6,14,2,13.3,2h-2.7C9.9,2,9.3,2.6,9.3,3.4v17.2c0,0.7,0.6,1.4,1.4,1.4H13.3L13.3,22z","key":0}),React.createElement("path",{"d":"M22,10.7c0-0.8-0.7-1.4-1.5-1.4H3.4C2.6,9.4,2,10,2,10.7v2.7c0,0.8,0.6,1.4,1.4,1.4h17.2c0.7,0,1.4-0.6,1.4-1.4V10.7L22,10.7z","key":1})]);
}

PlusIcon.defaultProps = {"data-dmid":"dm-plus","viewBox":"0 0 24 24","width":"24","height":"24","role":"img","fill":"currentColor","pointerEvents":"none","color":"color2"};

module.exports = PlusIcon;

PlusIcon.default = PlusIcon;
